module.exports = __webpack_public_path__ + "img/venture-logo.a78362bf.jpg";